module.exports = __webpack_public_path__ + "static/genghis-khan-and-the-making-of-the-modern-world-10449cca9cfa905cf8da51210794e52b.jpg";